import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { IBookmarkService } from '@intigral/domain/lib/application/services/BookmarkService';
import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import { useQuery } from '@tanstack/react-query';
import h, { getCountry } from '../../helpers/common';
import user from '../../helpers/user';
import { getUserInfo } from '../../utils/user';
import { log } from '@intigral/utils';

const handleBookMarks = async (carousel: Carousel) => {
    const bookMarkService = container.resolve<IBookmarkService>(DI.SERVICES.IBookmarkService);
    const userInfo = getUserInfo();
    const productKey = h.getProductKey();

    const searchParams = {
        device: h.getDevice(),
        country: getCountry(),
        productKey: productKey,
    };
    const response = await bookMarkService.getWatchAgain(
        userInfo.apiKey,
        user.getProfileName(),
        userInfo.authToken,
        userInfo.identityToken,
        searchParams
    );
    return response?.data;
};

export const useWatchAgain = (carousel: Carousel) => {
    return useQuery({
        queryKey: ['watchAgain', carousel.id, carousel.dataSources?.[0]],
        queryFn: () => handleBookMarks(carousel),
        staleTime: 10 * 60 * 1000, // Consider data stale after 10 minutes
        //cacheTime: 30 * 60 * 1000, // Keep data in cache for 30 minutes
    });
};
